module.exports = __webpack_public_path__ + "img/pixiv_icon.a3143b6c.jpg";